module.exports = __webpack_public_path__ + "img/collection-lg-05.1c3d9af9.jpg";